/**
 * Read out and expose all features the site has
 *
 * TODO: Freeze the toggle object
 */

export default {
    SHOW_ESTIMATION_TOOL: !!process.env.GATSBY_FEATURE_SHOW_ESTIMATION_TOOL,
};
